import React from 'react'
import { PolicyPrivacyContainer } from './styles'
import PagesLayout from '..'

export default function PolicyPrivacy() {
  return (
    <PagesLayout
      title="Política de Privacidade"
      description="18 de Março de 2025"
    >
      <PolicyPrivacyContainer>
        <p>
          Esta Política de Privacidade descreve as nossas políticas e
          procedimentos sobre a recolha e utilização das suas informações ao
          utilizar o Serviço, informando-o sobre os seus direitos de privacidade
          e como a lei o protege.
        </p>
        <p>
          Utilizamos os seus dados pessoais para fornecer e melhorar o Serviço.
          Ao utilizar o Serviço, concorda com a recolha e utilização das
          informações de acordo com esta Política de Privacidade.
        </p>
        <h2>Interpretação e Definições</h2>
        <h3>Interpretação</h3>
        <p>
          As palavras cujas iniciais estejam em maiúsculas têm os significados
          definidos nas seguintes condições. As definições abaixo terão o mesmo
          significado independentemente de aparecerem no singular ou plural.
        </p>
        <h3>Definições</h3>
        <p>Para os propósitos desta Política de Privacidade:</p>
        <ul>
          <li>
            <p>
              <strong>Conta</strong> significa uma conta única criada para que
              possa aceder ao nosso Serviço ou a partes do mesmo.
            </p>
          </li>
          <li>
            <p>
              <strong>Afiliada</strong> significa uma entidade que controla, é
              controlada por, ou está sob controlo comum com uma parte, onde
              "controlo" significa a posse de 50% ou mais das ações,
              participações ou outros títulos que dêem direito de voto para a
              eleição de diretores ou outra autoridade gestora.
            </p>
          </li>
          <li>
            <p>
              <strong>Aplicação</strong> refere-se à KFamily Apps, o programa de
              software fornecido pela Empresa.
            </p>
          </li>
          <li>
            <p>
              <strong>Empresa</strong> (referida como "a Empresa", "Nós",
              "Nosso" ou "Nos") refere-se à KFamily LLC, Rua do Pinheiro, 701.
            </p>
          </li>
          <li>
            <p>
              <strong>Cookies</strong> são pequenos ficheiros colocados no seu
              dispositivo, contendo detalhes sobre o seu histórico de navegação
              no website.
            </p>
          </li>
          <li>
            <p>
              <strong>País</strong> refere-se a: Portugal
            </p>
          </li>
          <li>
            <p>
              <strong>Dispositivo</strong> significa qualquer dispositivo que
              possa aceder ao Serviço, como um computador, telemóvel ou tablet
              digital.
            </p>
          </li>
          <li>
            <p>
              <strong>Dados Pessoais</strong> são quaisquer informações que se
              relacionem com um indivíduo identificado ou identificável.
            </p>
          </li>
          <li>
            <p>
              <strong>Serviço</strong> refere-se à Aplicação ou ao Website ou
              ambos.
            </p>
          </li>
          <li>
            <p>
              <strong>Prestador de Serviços</strong> significa qualquer pessoa
              singular ou coletiva que processe os dados em nome da Empresa.
            </p>
          </li>
          <li>
            <p>
              <strong>Dados de Utilização</strong> referem-se a dados recolhidos
              automaticamente, gerados pela utilização do Serviço ou pela
              infraestrutura do Serviço.
            </p>
          </li>
          <li>
            <p>
              <strong>Website</strong> refere-se a KFamily, acessível em{' '}
              <a
                href="https://kfamily.pt"
                rel="external nofollow noopener noreferrer"
                target="_blank"
              >
                https://kfamily.pt
              </a>
            </p>
          </li>
          <li>
            <p>
              <strong>Você</strong> significa o indivíduo que acede ou utiliza o
              Serviço, ou a empresa ou entidade legal em nome da qual tal
              indivíduo está a aceder ou utilizar o Serviço.
            </p>
          </li>
        </ul>
        <h2>Recolha e Utilização dos Seus Dados Pessoais</h2>
        <h3>Tipos de Dados Recolhidos</h3>
        <h4>Dados Pessoais</h4>
        <p>
          Ao utilizar o nosso Serviço, podemos pedir-lhe que nos forneça certas
          informações pessoalmente identificáveis, incluindo, mas não se
          limitando a:
        </p>
        <ul>
          <li>
            <p>Endereço de email</p>
          </li>
          <li>
            <p>Nome e apelido</p>
          </li>
          <li>
            <p>Número de telefone</p>
          </li>
          <li>
            <p>Endereço, Estado, Província, Código Postal, Cidade</p>
          </li>
          <li>
            <p>Dados de Utilização</p>
          </li>
        </ul>
        <h4>Utilização dos Dados</h4>
        <p>Os Dados são coletados automaticamente ao usar o Serviço.</p>
        <p>
          Os Dados de Uso podem incluir informações como o endereço de Protocolo
          de Internet do seu Dispositivo (por exemplo, endereço IP), tipo de
          navegador, versão do navegador, as páginas do nosso Serviço que Você
          visita, a hora e a data da sua visita, o tempo gasto nessas páginas,
          identificadores exclusivos do dispositivo e outros dados de
          diagnóstico.
        </p>
        <p>
          Quando você acessa o Serviço por ou através de um dispositivo móvel,
          podemos coletar certas informações automaticamente, incluindo, mas não
          se limitando a, o tipo de dispositivo móvel que você usa, o ID
          exclusivo do seu dispositivo móvel, o endereço IP do seu dispositivo
          móvel, seu sistema operacional móvel, o tipo de navegador de Internet
          móvel que você usa, identificadores exclusivos do dispositivo e outros
          dados de diagnóstico.
        </p>
        <p>
          Também podemos coletar informações que seu navegador envia sempre que
          você visita nosso Serviço ou quando acessa o Serviço por ou através de
          um dispositivo móvel.
        </p>
        <h4>Tecnologias de rastreamento e cookies</h4>
        <p>
          Não usamos cookies. Utilizamos serviços os serviços da Google Cloud
          Platform e todo o seu ecossistema.
        </p>
        <h3>Utilizaçãou dos seus Dados Pessoais</h3>
        <p>
          A Empresa poderá utilizar Dados Pessoais para as seguintes
          finalidades:
        </p>
        <ul>
          <li>
            <p>
              <strong>Para fornecer e manter nosso serviço</strong>, incluindo
              monitorar o uso do nosso Serviço.
            </p>
          </li>
          <li>
            <p>
              <strong>Para gerenciar sua conta:</strong> para administrar seu
              registro como usuário do Serviço. Os Dados Pessoais fornecidos
              podem conceder acesso a diferentes funcionalidades do Serviço
              disponíveis para usuários registrados.
            </p>
          </li>
          <li>
            <p>
              <strong>Para a execução de um contrato:</strong> desenvolvimento,
              cumprimento e execução do contrato de compra de produtos, itens ou
              serviços adquiridos ou qualquer outro contrato celebrado através
              do Serviço.
            </p>
          </li>
          <li>
            <p>
              <strong>Para contatar você:</strong> por e-mail, chamadas
              telefônicas, SMS ou outros meios eletrônicos, como notificações
              push sobre atualizações ou comunicações informativas relacionadas
              a funcionalidades, produtos ou serviços contratados, incluindo
              atualizações de segurança.
            </p>
          </li>
          <li>
            <p>
              <strong>Para fornecer a Você</strong> notícias, ofertas especiais
              e informações gerais sobre outros bens, serviços e eventos que
              oferecemos que são semelhantes aos que você já comprou ou
              perguntou, a menos que Você tenha optado por não receber tais
              informações.
            </p>
          </li>
          <li>
            <p>
              <strong>Para gerenciar Suas solicitações:</strong> Para atender e
              gerenciar Suas solicitações para Nós.
            </p>
          </li>
          <li>
            <p>
              <strong>Para outros fins</strong>: Podemos usar suas informações
              para outros fins, como análise de dados, identificação de
              tendências de uso , determinação da eficácia de nossas campanhas
              promocionais e para avaliar e melhorar nosso Serviço, produtos,
              serviços, marketing e sua experiência.
            </p>
          </li>
        </ul>
        <p>
          Podemos compartilhar suas informações pessoais nas seguintes
          situações:
        </p>
        <ul>
          <li>
            <p>
              <strong>Com Provedores de Serviços:</strong> Podemos compartilhar
              Suas informações pessoais com Provedores de Serviços para
              monitorar e analisar o uso de nosso Serviço, para entrar em
              contato com Você.
            </p>
          </li>
          <li>
            <p>
              <strong>Para transferências comerciais:</strong> Podemos
              compartilhar ou transferir Suas informações pessoais em conexão
              com, ou durante negociações de, qualquer fusão, venda de ativos da
              Empresa, financiamento ou aquisição de todo ou parte de Nosso
              negócio para outra empresa.
            </p>
          </li>
          <li>
            <p>
              <strong>Com Afiliados:</strong> Podemos compartilhar Suas
              informações com Nossos afiliados, caso em que exigiremos que esses
              afiliados honrem esta Política de Privacidade. Afiliados incluem
              Nossa empresa controladora e quaisquer outras subsidiárias,
              parceiros de joint venture ou outras empresas que controlamos ou
              que estão sob controle comum conosco.
            </p>
          </li>
          <li>
            <p>
              <strong>Com parceiros comerciais:</strong> Podemos compartilhar
              Suas informações com Nossos parceiros comerciais para oferecer a
              Você certos produtos, serviços ou promoções.
            </p>
          </li>
          <li>
            <p>
              <strong>Com outros usuários:</strong> quando Você compartilha
              informações pessoais ou interage de outra forma nas áreas públicas
              com outros usuários, tais informações podem ser visualizadas por
              todos os usuários e podem ser distribuídas publicamente fora.
            </p>
          </li>
          <li>
            <p>
              <strong>Com Seu consentimento</strong>: Podemos divulgar Suas
              informações pessoais para qualquer outra finalidade com Seu
              consentimento.
            </p>
          </li>
        </ul>
        <h3>Retention of Your Personal Data</h3>
        <p>
          A Empresa reterá Seus Dados Pessoais apenas pelo tempo que for
          necessário para os propósitos definidos nesta Política de Privacidade.
          Nós reteremos e usaremos Seus Dados Pessoais na medida necessária para
          cumprir com nossas obrigações legais (por exemplo, se formos obrigados
          a reter seus dados para cumprir com as leis aplicáveis), resolver
          disputas e aplicar nossos acordos e políticas legais.
        </p>
        <p>
          A Empresa também reterá Dados de Uso para fins de análise interna. Os
          Dados de Uso são geralmente retidos por um período de tempo mais
          curto, exceto quando esses dados são usados para fortalecer a
          segurança ou para melhorar a funcionalidade do Nosso Serviço, ou somos
          legalmente obrigados a reter esses dados por períodos de tempo mais
          longos.
        </p>
        <h3>Transferência de seus dados pessoais</h3>
        <p>
          Suas informações, incluindo dados pessoais, são processadas nos
          escritórios operacionais da empresa e em quaisquer outros lugares onde
          as partes envolvidas no processamento estejam localizadas. Isso
          significa que essas informações podem ser transferidas para — e
          mantidas em — computadores localizados fora de seu estado, província,
          país ou outra jurisdição governamental onde as leis de proteção de
          dados podem diferir daquelas de sua jurisdição.
        </p>
        <p>
          Seu consentimento com esta Política de Privacidade seguido pelo Seu
          envio de tais informações representa Sua concordância com essa
          transferência.
        </p>
        <p>
          A empresa tomará todas as medidas razoavelmente necessárias para
          garantir que Seus dados sejam tratados com segurança e de acordo com
          esta Política de Privacidade e nenhuma transferência de seus dados
          pessoais ocorrerá para uma organização ou um país, a menos que haja
          controles adequados em vigor incluindo a segurança de seus dados e
          outras informações pessoais.
        </p>
        <h3>Excluir seus dados pessoais</h3>
        <p>
          Você tem o direito de excluir ou solicitar que ajudemos a excluir os
          Dados pessoais que coletamos sobre você.
        </p>
        <p>
          Nosso serviço pode dar a você a capacidade de excluir certas
          informações sobre você de dentro do serviço.
        </p>
        <p>
          Você pode atualizar, alterar ou excluir suas informações a qualquer
          momento acessando sua conta, se tiver uma, e visitando a seção de
          configurações da conta que permite que você gerencie suas informações
          pessoais. Você também pode entrar em contato conosco para solicitar
          acesso, corrigir ou excluir qualquer informação pessoal que você nos
          forneceu.
        </p>
        <p>
          Observe, no entanto, que podemos precisar reter certas informações
          quando tivermos uma obrigação legal ou base legal para fazê-lo.
        </p>
        <h3>Divulgação de seus dados pessoais</h3>
        <h4>Transações comerciais</h4>
        <p>
          Se a empresa estiver envolvida em uma fusão, aquisição ou venda de
          ativos, seus dados pessoais podem ser transferidos. Forneceremos um
          aviso antes seus dados pessoais são transferidos e se tornam sujeitos
          a uma Política de privacidade diferente.
        </p>
        <h4>Aplicação da lei</h4>
        <p>
          Em certas circunstâncias, a empresa pode ser obrigada a divulgar seus
          dados pessoais se exigido por lei ou em resposta a solicitações
          válidas de autoridades públicas (por exemplo, um tribunal ou uma
          agência governamental).
        </p>
        <h4>Outros requisitos legais</h4>
        <p>
          A Empresa pode divulgar Seus Dados Pessoais acreditando de boa fé que
          tal ação é necessária para:
        </p>
        <ul>
          <li>
            <p>Cumprir com uma obrigação legal</p>
          </li>
          <li>
            <p>Proteger e defender os direitos ou propriedade da Empresa</p>
          </li>
          <li>
            <p>
              Prevenir ou investigar possíveis irregularidades em conexão com o
              Serviço
            </p>
          </li>
          <li>
            <p>
              Proteger a segurança pessoal dos Usuários do Serviço ou do público
            </p>
          </li>
          <li>
            <p>Proteger contra responsabilidade legal</p>
          </li>
        </ul>
        <h3>Segurança dos seus dados pessoais</h3>
        <p>
          A segurança dos seus dados pessoais é importante para nós, mas
          lembre-se de que nenhum método de transmissão pela Internet ou método
          de armazenamento eletrônico é 100% seguro. Embora nos esforcemos para
          usar meios comercialmente aceitáveis para proteger seus dados
          pessoais, não podemos garantir sua segurança absoluta.
        </p>
        <h2>Privacidade das crianças</h2>
        <p>
          Nosso serviço não se dirige a menores de 13 anos. Não coletamos
          intencionalmente informações de identificação pessoal de ninguém com
          menos de 13 anos. Se você for pai/mãe ou responsável e estiver ciente
          de que seu filho nos forneceu dados pessoais, entre em contato
          conosco. Se tomarmos conhecimento de que coletamos dados pessoais de
          alguém com menos de 13 anos sem verificação do consentimento dos pais,
          tomaremos medidas para remover essas informações de nossos servidores.
        </p>
        <p>
          Se precisarmos confiar no consentimento como base legal para processar
          Suas informações e Seu país exigir o consentimento de um dos pais,
          podemos exigir o consentimento de Seus pais antes de coletar e usar
          essas informações.
        </p>
        <h2>Links para outros sites</h2>
        <p>
          Nosso Serviço pode conter links para outros sites que não são operados
          por Nós. Se Você clicar em um link de terceiros, Você será direcionado
          para o site desse terceiro. Recomendamos fortemente que Você revise a
          Política de Privacidade de cada site que Você visitar.
        </p>
        <p>
          Não temos controle e não assumimos nenhuma responsabilidade pelo
          conteúdo, políticas de privacidade ou práticas de quaisquer sites ou
          serviços de terceiros.
        </p>
        <h2>Alterações nesta Política de Privacidade</h2>
        <p>
          Podemos atualizar Nossa Política de Privacidade de tempos em tempos.
          Nós o notificaremos sobre quaisquer alterações publicando a nova
          Política de Privacidade nesta página.
        </p>
        <p>
          Avisaremos Você por e-mail e/ou um aviso destacado em Nosso Serviço,
          antes que a alteração se torne efetiva e atualizaremos a data da
          "Última atualização" no topo desta Política de Privacidade.
        </p>
        <p>
          É aconselhável que você revise esta Política de Privacidade
          periodicamente para quaisquer alterações. As alterações a esta
          Política de Privacidade entram em vigor quando são publicadas nesta
          página.
        </p>
        <h2>Contacte-nos</h2>
        <p>
          Caso tenha alguma questão sobre esta Política de Privacidade, pode
          contactar-nos :
        </p>
        <ul>
          <li>
            <p>Por email: geral@4mr.pt</p>
          </li>
          <li>
            <p>
              Visitando esta página no nosso website:{' '}
              <a
                href="https://kfamily.pt#contacto"
                rel="external nofollow noopener noreferrer"
                target="_blank"
              >
                https://kfamily.pt#contacto
              </a>
            </p>
          </li>
          <li>
            <p>Por telefone: 910774611</p>
          </li>
          <li>
            <p>Por correio: Rua do Pinheiro, 701</p>
          </li>
        </ul>
        <br />
        <br />
      </PolicyPrivacyContainer>
    </PagesLayout>
  )
}
